import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';

import CautionIcon from '~/shared/assets/icons/caution.svg';
import Button from '~/shared/components/ButtonsV2';
import Typography from '~/shared/components/Typography';

interface RevertAllModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function RevertAllModal({ isOpen, onClose, onConfirm }: RevertAllModalProps) {
  return (
    <Dialog open={isOpen} as="div" className="relative z-[99] focus:outline-none" onClose={onClose}>
      <div className="fixed inset-0 p-4 w-screen overflow-y-auto bg-[#00000059] backdrop-blur-[6px]">
        <div className="flex items-center justify-center h-full p-4">
          <DialogPanel
            transition
            className="flex w-full max-w-[689px] flex-col rounded-xl bg-white p-6 backdrop-blur2xl duration-300 ease-out overflow-hidden data-closed:transform-[scale(95%)] data-closed:opacity-0"
          >
            <div className="py-2.5">
              <DialogHeader
                title="Are you sure you want to revert all configurations to default?"
                description="This action will return all configurations at this level to their default or inherited values"
              />
            </div>

            <DialogFooter onCancel={onClose} onConfirm={onConfirm} />
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}

function DialogHeader({ title, description }: { title: string; description: string }) {
  return (
    <div className="flex flex-col font-family-outfit items-center text-center">
      <CautionIcon className="size-10 text-red " />
      <DialogTitle as="h3">
        <Typography variant="H3-med" fontWeight={600} className="mt-6 font-family-outfit">
          {title}
        </Typography>
      </DialogTitle>
      <Typography variant="p3-reg" className="mt-2 max-w-[536px] text-center">
        {description}
      </Typography>
    </div>
  );
}

function DialogFooter({ onCancel, onConfirm }: { onCancel: () => void; onConfirm: () => void }) {
  return (
    <div className="mt-auto flex items-center justify-center gap-2 pt-6">
      <div className="flex gap-2">
        <Button onClick={onCancel} variant="third" className="px-5">
          No, cancel
        </Button>
        <Button onClick={onConfirm} className="px-7">
          Yes, Revert to default
        </Button>
      </div>
    </div>
  );
}
